import { render, staticRenderFns } from "./SpecificParam.vue?vue&type=template&id=5aa1ec55"
import script from "./SpecificParam.vue?vue&type=script&lang=js"
export * from "./SpecificParam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports